function AllGeneralPropertiesCtrl($scope, $state, $timeout){

	// get account id filter from parameters - currently not in use
	$scope.accountId = parseInt($state.params.accountId);
	$scope.properties = {};

	angular.element(document).ready( function (){
       	store.fetch({
       		method : 'GET',
       		url : `/allgeneralproperties?accountId=${$scope.accountId}`,
       		success: function(data, status, headers, config) {
       			$scope.properties = data;
    		}
    	});
    });
}